// Search results tabs: switch the per-type result panels of the current pagination page.
// Listeners are delegated from the section root because a facet AJAX refetch replaces both
// the tab row (inside the top bar) and the panels (inside #ProductGridContainer).
(function () {
  const SECTION_CLASS = "search-section";

  class SearchResultsTabs {
    constructor(section) {
      this.section = section;
      this.controller = new AbortController();

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      const signal = this.controller.signal;
      section.addEventListener("click", this.onClick, { signal });
      section.addEventListener("keydown", this.onKeydown, { signal });
    }

    destroy() {
      this.controller.abort();
    }

    getTabs() {
      return Array.from(this.section.querySelectorAll(".js-search-tab"));
    }

    onClick(event) {
      const tab = event.target.closest(".js-search-tab");
      if (!tab) return;

      event.preventDefault();
      this.activate(tab.dataset.typeTarget);
    }

    onKeydown(event) {
      if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;

      const tab = event.target.closest(".js-search-tab");
      if (!tab) return;

      const tabs = this.getTabs();
      const index = tabs.indexOf(tab);
      if (index === -1 || tabs.length < 2) return;

      event.preventDefault();
      const step = event.key === "ArrowRight" ? 1 : -1;
      const next = tabs[(index + step + tabs.length) % tabs.length];

      this.activate(next.dataset.typeTarget);
      next.focus();
    }

    activate(type) {
      if (!type) return;

      this.getTabs().forEach((tab) => {
        const isActive = tab.dataset.typeTarget === type;
        tab.classList.toggle("active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      this.section
        .querySelectorAll(".main-search__results-block[data-type]")
        .forEach((panel) => {
          panel.classList.toggle("active", panel.dataset.type === type);
        });

      // The density switcher sizes the product grid only, so it rides with the products tab.
      const gridToggle = this.section.querySelector("[data-grid-view-toggle]");
      if (gridToggle) gridToggle.classList.toggle("hidden", type !== "products");
    }
  }

  function initSection(section) {
    if (!section || !section.classList) return;
    if (!section.classList.contains(SECTION_CLASS)) return;
    if (!section.querySelector("[data-search-tabs]")) return;

    if (section._searchResultsTabs) {
      section._searchResultsTabs.destroy();
      section._searchResultsTabs = null;
    }

    section._searchResultsTabs = new SearchResultsTabs(section);
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeSearchResultsTabsEvents) {
    window.__themeSearchResultsTabsEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      const section = event.target;
      if (!section || !section._searchResultsTabs) return;

      section._searchResultsTabs.destroy();
      section._searchResultsTabs = null;
    });
  }
})();
